import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCurrentUser,
  returnSuperAdmin,
  setRegionToken,
  ssoJWTCheck,
} from "../../services/authService";
import styles from "./hall.module.css";
import { isMobile } from "react-device-detect";
import SideMenu from "../common/sideMenu/sideMenu";
import { Navbar, Container, Nav } from "react-bootstrap";
import "./hall.css";
import Slider from "react-slick";
function EntranceHall() {
  const [backDrop, setbackDrop] = useState(true);
  const soundRef = React.useRef();
  const infoRef = React.useRef();
  const history = useNavigate();
  const [IsAdmin, setIsAdmin] = useState();
  const [regionButtons, setRegionButtons] = useState(true);
  const [region, setRegion] = useState("");
  const [announcementsCount, setAnnouncementsCount] = useState(0);
  const [loading, setloading] = useState(true);
  const [loadingCount, setloadingCount] = useState(0);
  const iframeRef = useRef(null);

  useEffect(() => {
    // Check if the iframe reference exists
    if (iframeRef.current) {
      // Set focus to the iframe
      iframeRef.current.focus();
    }
  }, []);
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,

    cssEase: "linear",
  };

  useEffect(() => {
    if (!isMobile)
      if (
        window.localStorage.getItem("firstLoad") == "true" ||
        window.localStorage.getItem("firstLoad") == null ||
        window.localStorage.getItem("firstLoad") == undefined
      ) {
        interval = setTimeout(() => {
          document.getElementsByClassName("showclass")[0].className =
            "popover__content";
          localStorage.setItem("firstLoad", "false");
        }, 80000);
      }
  }, []);
  let interval;
  useEffect(() => {
    if (
      window.localStorage.getItem("firstLoad") == "true" ||
      window.localStorage.getItem("firstLoad") == null ||
      window.localStorage.getItem("firstLoad") == undefined
    ) {
      interval = setInterval(() => {
        let count = loadingCount;
        if (loadingCount < 100) {
          {
            setloadingCount(parseInt(count) + 1);

            if (loadingCount >= 25 && loadingCount < 50) {
              document.getElementById("loadingsecondsection").className =
                styles["first-section"];
              document.getElementById("loadingfirstsection").className =
                styles["other-section"];
              document.getElementById("loadingthirdsection").className =
                styles["other-section"];

              document.getElementById("loadingfourthsection").className =
                styles["other-section"];
            }
            if (loadingCount >= 50 && loadingCount < 75) {
              document.getElementById("loadingsecondsection").className =
                styles["other-section"];
              document.getElementById("loadingthirdsection").className =
                styles["first-section"];
              document.getElementById("loadingfirstsection").style.display =
                "none";
              document.getElementById("loadingfourthsection").className =
                styles["other-section"];
            }
            if (loadingCount >= 75) {
              document.getElementById("loadingsecondsection").className =
                styles["other-section"];
              document.getElementById("loadingthirdsection").className =
                styles["other-section"];
              document.getElementById("loadingfirstsection").className =
                styles["other-section"];
              document.getElementById("loadingfourthsection").className =
                styles["first-section"];
            }
          }
        } else {
          setloading(false);
          //   window.localStorage.setItem("firstLoad", "false");
        }
      }, 600);
      return () => {
        clearInterval(interval);
      };
    } else {
      interval = setInterval(() => {
        let count = loadingCount;
        if (loadingCount < 100) {
          {
            setloadingCount(parseInt(count) + 1);
          }
        } else {
          setloading(false);
          //   window.localStorage.setItem("firstLoad", "false");
        }
      }, 200);
      return () => {
        clearInterval(interval);
      };
    }
  }, [loadingCount]);
  if (isMobile) {
    return (
      <div className='mobile-bg'>
        <div className='mobile-bg-div'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='86'
            height='23'
            viewBox='0 0 86 23'
            fill='none'
          >
            <g filter='url(#filter0_f_468_3830)'>
              <path
                d='M21.7584 20.1164L15.4141 1.39331H17.0423L22.544 18.1236L28.271 1.39331H29.7583L23.2192 20.1164H21.7584Z'
                fill='white'
              />
              <path
                d='M50.7276 10.741C50.7287 11.9472 50.5826 13.1491 50.2925 14.3199C50.03 15.425 49.584 16.4783 48.9731 17.4359C48.396 18.3317 47.6236 19.0851 46.7137 19.6397C45.7296 20.1895 44.6216 20.4793 43.4944 20.4818C42.3672 20.4842 41.2579 20.1992 40.2715 19.6536C39.3622 19.0999 38.5862 18.3523 37.9991 17.4642C37.3715 16.5122 36.9155 15.4576 36.6519 14.3482C36.3603 13.168 36.2142 11.9566 36.2168 10.741C36.2135 9.51424 36.3694 8.29222 36.6806 7.10557C36.9601 6.00129 37.425 4.95249 38.0557 4.00392C38.6439 3.12417 39.4201 2.38589 40.3281 1.84231C41.2863 1.28702 42.3787 1.00594 43.4859 1.0298C44.6178 1.00299 45.735 1.28964 46.7141 1.85808C47.6246 2.404 48.3974 3.15201 48.9727 4.04426C49.5835 5.00194 50.0294 6.0552 50.2921 7.16029C50.5821 8.33112 50.7282 9.53295 50.7271 10.7392M49.211 10.7392C49.211 9.72863 49.098 8.72128 48.8744 7.73582C48.6706 6.79788 48.3202 5.89794 47.836 5.06918C47.3888 4.30598 46.7802 3.64975 46.0528 3.14642C45.2938 2.63985 44.3967 2.38065 43.4845 2.40439C42.5697 2.38218 41.6696 2.6366 40.9018 3.13436C40.1637 3.62943 39.5491 4.28722 39.1052 5.05712C38.6221 5.89157 38.2716 6.79604 38.0663 7.73814C37.8425 8.72358 37.7296 9.73095 37.7296 10.7415C37.7299 11.7575 37.8476 12.7701 38.0803 13.7592C38.2931 14.7078 38.653 15.6172 39.1469 16.4546C39.597 17.2194 40.2109 17.8751 40.9445 18.3746C41.6972 18.8709 42.5835 19.1256 43.485 19.1045C44.3881 19.1257 45.2757 18.8665 46.0255 18.3625C46.7573 17.8548 47.3702 17.1943 47.8221 16.4268C48.3137 15.5949 48.6691 14.6898 48.8748 13.7457C49.0985 12.7603 49.2115 11.7529 49.2115 10.7424'
                fill='white'
              />
              <path
                d='M63.3882 1.39331H59.7949V20.1164H63.3882V1.39331Z'
                fill='white'
              />
              <path
                d='M10.9426 20.3975H1V21.8699H10.9426V20.3975Z'
                fill='white'
              />
              <path
                d='M78.2652 20.5096C79.1597 20.4899 80.0473 20.3482 80.9035 20.0885C81.941 19.7777 82.8606 19.1613 83.5423 18.3197C84.3082 17.388 84.7162 16.2134 84.6929 15.0075C84.682 13.9359 84.4098 12.8832 83.8999 11.9407C82.8796 10.2734 80.9318 9.50358 79.163 8.88816C78.5382 8.676 77.9245 8.43253 77.3242 8.15866C76.949 7.99062 76.5876 7.79354 76.2431 7.56922C76.0183 7.39489 75.8395 7.16816 75.7224 6.90882C75.6054 6.64948 75.5536 6.36543 75.5716 6.08146C75.5678 5.82128 75.6182 5.56315 75.7198 5.32359C75.8214 5.08402 75.9718 4.86828 76.1615 4.69017C76.5545 4.30679 77.2375 4.11495 78.2104 4.11464C78.581 4.1125 78.9499 4.16452 79.3054 4.26907C79.9247 4.44093 80.5262 4.67122 81.102 4.95684C81.7009 5.21535 82.2443 5.58696 82.7025 6.05132L84.583 3.55349C84.1938 3.14244 83.7606 2.77527 83.2914 2.45854C82.6305 2.00814 81.9062 1.65865 81.1423 1.42156C80.2399 1.13292 79.297 0.990751 78.3496 1.00047C77.3192 1.00071 76.2956 1.16653 75.3179 1.49159C74.3575 1.79549 73.5271 2.41338 72.9602 3.24601C72.3592 4.11917 72.0542 5.16213 72.0901 6.22152C72.0319 7.11813 72.2121 8.01417 72.6123 8.8186C73.5055 10.4696 75.33 11.2895 77.058 11.7797C78.7235 12.3597 79.8277 12.8744 80.3706 13.3236C80.6266 13.5508 80.8279 13.833 80.9592 14.149C81.0905 14.4651 81.1485 14.8068 81.1289 15.1485C81.1375 15.4536 81.0717 15.7561 80.9371 16.03C80.8026 16.3039 80.6034 16.541 80.3567 16.7207C79.7346 17.1455 78.9895 17.3527 78.2373 17.3101C77.6661 17.3155 77.0961 17.2543 76.539 17.1279C75.6712 16.9308 74.8478 16.5738 74.1108 16.0751C73.8663 15.9116 73.632 15.7335 73.4091 15.5418L71.8926 18.6578C72.1476 18.844 72.4148 19.0127 72.6926 19.1628C73.1292 19.4007 73.5846 19.6023 74.0542 19.7657C74.6683 19.9822 75.2966 20.1557 75.9347 20.2852C76.7014 20.4402 77.4821 20.5154 78.2642 20.5096'
                fill='white'
              />
            </g>
            <defs>
              <filter
                id='filter0_f_468_3830'
                x='0'
                y='0'
                width='85.6934'
                height='22.8699'
                filterUnits='userSpaceOnUse'
                color-interpolation-filters='sRGB'
              >
                <feFlood flood-opacity='0' result='BackgroundImageFix' />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='BackgroundImageFix'
                  result='shape'
                />
                <feGaussianBlur
                  stdDeviation='0.5'
                  result='effect1_foregroundBlur_468_3830'
                />
              </filter>
            </defs>
          </svg>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='668'
            height='90'
            viewBox='0 0 668 90'
            fill='none'
            className='hack'
          >
            <path
              d='M173.926 25.7187C175.329 23.8162 177.164 22.2741 179.28 21.2193C181.395 20.1645 183.731 19.627 186.095 19.6511C187.954 19.615 189.802 19.9486 191.532 20.6325C192.987 21.222 194.353 22.0117 195.589 22.9788C196.629 23.7991 197.551 24.7575 198.331 25.8275C198.901 26.6194 199.431 27.4396 199.918 28.2851L210.226 19.6485C209.303 18.0949 208.238 16.6306 207.044 15.2745C204.77 12.7993 202.006 10.8254 198.927 9.47878C194.842 7.58111 190.377 6.64725 185.875 6.74925C181.906 6.75411 177.977 7.53258 174.306 9.04112C170.477 10.6158 167.047 13.0249 164.266 16.0928C161.158 19.5672 158.757 23.6132 157.195 28.0054C155.29 33.4645 154.38 39.221 154.507 45.0015C154.41 50.5358 155.188 56.0507 156.812 61.3424C158.149 65.6851 160.37 69.7046 163.334 73.1488C166.077 76.2632 169.496 78.7104 173.328 80.3041C177.349 81.9408 181.656 82.7578 185.996 82.7073C190.469 82.5954 194.909 81.8989 199.201 80.6356C202.984 79.9363 206.496 78.1945 209.343 75.6064L204.845 63.4737C202.922 65.179 200.737 66.5625 198.373 67.5706C194.993 69.0706 191.321 69.7987 187.625 69.7019C184.999 69.7884 182.39 69.2545 180.009 68.1436C177.628 67.0327 175.542 65.376 173.921 63.308C170.48 59.0453 168.763 52.944 168.768 45.0041C168.695 41.1512 169.156 37.3067 170.14 33.581C170.893 30.7442 172.178 28.0763 173.926 25.7187ZM270.92 45.0067C269.786 43.6423 268.382 42.527 266.796 41.7307C268.136 40.9697 269.325 39.969 270.304 38.7785C271.487 37.2239 272.482 35.535 273.269 33.7467L284.783 8.28234H269.978L259.559 31.776C258.933 33.6427 257.838 35.3167 256.377 36.6368C255.303 37.3433 254.038 37.7047 252.752 37.6727H245.412V8.30306H231.374V81.182H245.412V49.9297H253.64C254.551 49.87 255.462 50.0266 256.301 50.3867C257.139 50.7467 257.88 51.3001 258.464 52.0014C259.886 53.9853 261.029 56.1549 261.861 58.4497L270.853 81.1846H286.095L273.706 50.1472C273.053 48.2998 272.113 46.5667 270.92 45.0118V45.0067ZM101.223 8.29011L74.9039 81.182H89.271L108.244 25.4468L127.218 81.182H141.585L115.144 8.29011H101.223ZM325.256 8.29011L298.938 81.182H313.305L332.278 25.4468L351.251 81.182H365.618L339.183 8.29011H325.256ZM41.799 37.1418H14.1521V8.29011H0.11377V81.182H14.1521V50.3647H41.799V81.1638H55.8374V8.29011H41.799V37.1418ZM653.356 8.29011V53.752L625.173 8.29011H610.806V81.1638H624.733V32.9957L654.886 81.1872H667.171V8.29011H653.356ZM573.742 13.3193C569.118 9.71614 563.569 7.49643 557.736 6.91713C551.904 6.33782 546.026 7.42262 540.785 10.0459C536.873 12.1699 533.468 15.1164 530.803 18.6825C528.09 22.3441 526.065 26.4682 524.825 30.854C522.19 39.8831 522.19 49.4776 524.825 58.5067C526.059 62.8945 528.085 67.0195 530.803 70.6782C533.473 74.2527 536.876 77.2143 540.785 79.364C545.079 81.6642 549.896 82.8133 554.766 82.6995C559.705 82.812 564.592 81.6641 568.965 79.364C572.92 77.2347 576.366 74.271 579.063 70.6782C581.779 67.0102 583.822 62.8891 585.098 58.5067C586.439 54.0205 587.121 49.3629 587.123 44.6804C586.937 39.2891 585.977 33.9526 584.275 28.8341C582.369 22.7375 578.704 17.34 573.742 13.3193ZM571.223 55.5001C570.567 57.6978 569.646 59.8075 568.481 61.7826C567.103 64.0708 565.183 65.9847 562.891 67.3557C560.468 68.9033 557.649 69.7181 554.774 69.7019C552.088 69.7489 549.444 69.0303 547.151 67.6301C544.892 66.2172 542.981 64.3121 541.561 62.0571C540.001 59.5834 538.853 56.8719 538.164 54.0291C536.633 47.896 536.633 41.4802 538.164 35.3471C538.856 32.5053 540.003 29.7942 541.561 27.3191C542.981 25.0641 544.892 23.1591 547.151 21.7461C549.444 20.346 552.088 19.6274 554.774 19.6744C557.858 19.7257 560.864 20.6545 563.44 22.3521C566.594 24.5249 568.975 27.6448 570.239 31.2606C572.013 35.5182 572.908 40.091 572.869 44.7037C572.795 48.359 572.241 51.9888 571.223 55.5001ZM368.35 21.5182H389.079V81.1897H403.117V21.5182H423.846V8.29788H368.355V21.5182H368.35ZM485.03 37.1418H457.396V8.30306H443.358V81.182H457.396V50.3647H485.03V81.182H499.068V8.29011H485.03V37.1418ZM41.799 4.09741H55.8374V0.0808105H41.799V4.09741ZM457.396 0.267268H443.358V4.28128H457.396V0.267268ZM610.697 89.2022H624.735V85.1856H610.697V89.2022Z'
              fill='white'
            />
          </svg>
          <span className='mobile-bg-text'>
            To ensure a smooth 3D experience, please use your laptop or desktop
            to explore our 3d environment.
          </span>
        </div>
        <img
          className='img-disclaimer'
          src='/assets/mobile-view-disclaimer.png'
        ></img>
      </div>
    );
  } else {
    return (
      <>
        {loading ? (
          <>
            <div className={styles["wiv-joinOuterContainer"]}>
              {window.localStorage.getItem("firstLoad") == "false" ? (
                <div className={styles["header-div"]}>
                  <div
                    className={styles["skipDiv"]}
                    onClick={() => {
                      // window.localStorage.setItem("firstLoad", "false");

                      setloadingCount(100);
                      iframeRef.current.focus();
                    }}
                  >
                    <span className={styles["skip-text"]}>SKIP</span>
                    <i class='fa fa-chevron-right ml-2'></i>
                  </div>
                </div>
              ) : null}
              <img
                src='/assets/_vois_white.png'
                className={styles["welcome-text"]}
              ></img>
              <img
                src='/assets/hack.png'
                className={styles["welcome-text2"]}
              ></img>

              <div id='loadingfirstsection' className={styles["first-section"]}>
                <img
                  src='/assets/instructions/ins1.svg'
                  className={styles["img"]}
                ></img>
              </div>
              <div
                id='loadingsecondsection'
                className={styles["other-section"]}
              >
                <img
                  src='/assets/instructions/ins2.svg'
                  className={styles["img"]}
                ></img>
              </div>
              <div id='loadingthirdsection' className={styles["other-section"]}>
                <img
                  src='/assets/instructions/ins3.svg'
                  className={styles["img"]}
                ></img>
              </div>
              <div
                id='loadingfourthsection'
                className={styles["other-section"]}
              >
                <img
                  src='/assets/instructions/ins4.svg'
                  className={styles["img"]}
                ></img>
              </div>
              <label className={styles["Loading-title"]}>
                Loading .. {loadingCount} %
              </label>

              <div
                class='progress '
                style={{
                  width: "30%",
                  height: "0.5rem",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  class='progress-bar'
                  role='progressbar'
                  style={{
                    width: `${loadingCount}%`,
                    backgroundColor: "#BE0000",
                    fontFamily: "Polaris !important",
                  }}
                  aria-valuenow={`${loadingCount}`}
                  aria-valuemin='0'
                  aria-valuemax='100'
                ></div>
              </div>
            </div>
          </>
        ) : null}
        <div
          class='modal fade'
          id='infoModal'
          tabindex='-1'
          role='dialog'
          aria-labelledby='exampleModalLabel'
          aria-hidden='true'
          data-backdrop='static'
          data-keyboard='false'
        >
          <div class='modal-dialog modal-info-body' role='document'>
            <div class='modal-content modal-content-info'>
              <div class='modal-body modal-info-body'>
                <div className='modal-info-header'>
                  <span className='info-header'>INSTRUCTIONS</span>
                  <button
                    data-dismiss='modal'
                    aria-label='Close'
                    className='close-btn'
                    onClick={() => {
                      localStorage.setItem("firstLoad", "false");
                      iframeRef.current.focus();
                    }}
                  >
                    Hide
                  </button>
                </div>
                <div className={styles["moving-logo"]}>
                  <div className={styles["instructionslick-ss"]}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='menu'>
          {/* <img
            src='/assets/notifications.svg'
            style={{ cursor: "pointer" }}
            className='mr-2'
            onClick={() => {
              history("/announcments");
            }}
          ></img> */}
          <div class='popover__wrapper'>
            <div
              class={
                localStorage.getItem("firstLoad") == "true" ||
                localStorage.getItem("firstLoad") == null ||
                localStorage.getItem("firstLoad") == undefined
                  ? "showclass popover__content "
                  : "popover__content"
              }
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='338'
                height='72'
                viewBox='0 0 338 72'
                fill='none'
              >
                <mask id='path-1-inside-1_713_3714' fill='white'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M4 0C1.79086 0 0 1.79086 0 4V68C0 70.2091 1.79085 72 3.99999 72H323.299C325.508 72 327.299 70.2091 327.299 68V44.9203L337.44 36L327.299 27.0797V4C327.299 1.79086 325.508 0 323.299 0H4Z'
                  />
                </mask>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M4 0C1.79086 0 0 1.79086 0 4V68C0 70.2091 1.79085 72 3.99999 72H323.299C325.508 72 327.299 70.2091 327.299 68V44.9203L337.44 36L327.299 27.0797V4C327.299 1.79086 325.508 0 323.299 0H4Z'
                  fill='white'
                />
                <path
                  d='M327.299 44.9203L326.638 44.1694L326.299 44.4681V44.9203H327.299ZM337.44 36L338.1 36.7508L338.954 36L338.1 35.2492L337.44 36ZM327.299 27.0797H326.299V27.5319L326.638 27.8306L327.299 27.0797ZM1 4C1 2.34315 2.34315 1 4 1V-1C1.23858 -1 -1 1.23858 -1 4H1ZM1 68V4H-1V68H1ZM3.99999 71C2.34314 71 1 69.6569 1 68H-1C-1 70.7614 1.23856 73 3.99999 73V71ZM323.299 71H3.99999V73H323.299V71ZM326.299 68C326.299 69.6569 324.956 71 323.299 71V73C326.06 73 328.299 70.7614 328.299 68H326.299ZM326.299 44.9203V68H328.299V44.9203H326.299ZM327.959 45.6711L338.1 36.7508L336.779 35.2492L326.638 44.1694L327.959 45.6711ZM338.1 35.2492L327.959 26.3289L326.638 27.8306L336.779 36.7508L338.1 35.2492ZM326.299 4V27.0797H328.299V4H326.299ZM323.299 1C324.956 1 326.299 2.34315 326.299 4H328.299C328.299 1.23858 326.06 -1 323.299 -1V1ZM4 1H323.299V-1H4V1Z'
                  fill='#DEE2E6'
                  mask='url(#path-1-inside-1_713_3714)'
                />
              </svg>
              <p class='popover__message'>
                Discover the ins and outs of our 3D platform with our
                comprehensive user guide.
              </p>
            </div>
            <img
              src='/assets/info2.svg'
              style={{ cursor: "pointer" }}
              className='mr-2 popover__title'
              data-toggle='modal'
              data-target='#infoModal'
              ref={infoRef}
            ></img>
          </div>

          {IsAdmin === "true" ? (
            <img
              src='/assets/back.svg'
              className='mr-2'
              style={{ cursor: "pointer" }}
              onClick={() => {
                returnSuperAdmin();
                history("/superadmin/home");
              }}
            ></img>
          ) : null}
        </div>

        <iframe
          src='/data/events/hack-b/index.html'
          className='halliframe'
          scrolling='no'
          ref={iframeRef}
        ></iframe>
      </>
    );
  }
}

export default EntranceHall;
